import * as React from 'react';

import { IconProps } from 'bones/design-system/components/icons/Icon';

export type ExplorerLogoProps = {
  title?: string;
} & IconProps &
  React.SVGProps<SVGSVGElement>;

export const ExplorerLogo: React.VFC<ExplorerLogoProps> = ({
  size,
  title,
  ...props
}) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 30 30"
    width={size}
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
  >
    {title ? <title>{title}</title> : null}
    <path
      d="M15 28.8667C22.732 28.8667 29 22.5987 29 14.8667C29 7.13471 22.732 0.866699 15 0.866699C7.26801 0.866699 1 7.13471 1 14.8667C1 22.5987 7.26801 28.8667 15 28.8667Z"
      fill="#05495F"
    />
    <path
      d="M4.13544 12.9807L1.10156 14.1159L1.42724 17.8445L2.72997 21.6818L5.03103 24.3968L6.05916 25.7362C6.05916 25.7362 7.38041 25.8006 8.94715 23.9262L5.03103 18.4961L4.13544 12.9807Z"
      fill="#007FA4"
    />
    <path
      d="M8.99942 24.96L7.07182 26.4239L4.75586 24.3967C4.75586 24.3967 4.90955 25.6869 7.39504 23.4302L8.99942 24.96Z"
      fill="#EFEFEF"
    />
    <path
      d="M15.0659 24.8825C20.6079 24.8825 25.1006 20.3899 25.1006 14.8479C25.1006 9.30589 20.6079 4.81323 15.0659 4.81323C9.5239 4.81323 5.03125 9.30589 5.03125 14.8479C5.03125 20.3899 9.5239 24.8825 15.0659 24.8825Z"
      fill="#05495F"
    />
    <path
      d="M15 28.8667C22.732 28.8667 29 22.5987 29 14.8667C29 7.13471 22.732 0.866699 15 0.866699C7.26801 0.866699 1 7.13471 1 14.8667C1 22.5987 7.26801 28.8667 15 28.8667Z"
      stroke="#007FA4"
      strokeMiterlimit="10"
      strokeWidth="0.502242"
    />
    <path
      d="M18.2817 14.0073C18.3201 13.8669 17.334 15.9086 16.9785 16.2669L16.4355 16.7368C16.4808 15.6426 16.3523 14.548 16.0547 13.494C16.8127 13.5884 17.5589 13.7603 18.2817 14.0073Z"
      fill="#EFEFEF"
    />
    <path
      d="M14.048 13.5367L13.9893 13.4484C14.3513 13.4313 14.7139 13.4363 15.0753 13.4636C15.0872 14.1247 14.9727 14.7821 14.7379 15.4003C14.582 14.7541 14.3504 14.1286 14.048 13.5367Z"
      fill="#EFEFEF"
    />
    <path
      d="M16.1759 18.3296C16.0166 19.3063 16.3678 20.2482 17.0266 20.9707C15.0573 22.1661 15.5322 19.2672 16.1759 18.3296Z"
      fill="#EFEFEF"
    />
    <path
      d="M14.8891 8.17912C14.1759 7.92644 12.1965 7.31033 11.5869 6.85132C11.6594 7.38273 12.1784 7.57532 12.2921 7.92572C12.4145 8.30655 12.2921 8.84955 12.3645 9.25933C12.7866 8.77063 13.8068 8.86837 14.2281 8.38039L14.8891 8.17912Z"
      fill="#EFEFEF"
    />
    <path
      d="M19.6432 11.7919C20.0153 11.8904 20.8218 12.3624 21.1534 12.5572C20.2846 13.0531 18.3117 13.1494 17.7383 12.951C17.9309 10.9289 18.8779 11.7289 19.5932 11.8752C20.1565 11.9903 19.6432 11.7919 19.6432 11.7919Z"
      fill="#007FA4"
    />
    <path
      d="M20.7213 12.3972C19.7417 12.0352 19.114 11.9628 18.332 11.6261C18.9757 11.2605 19.8923 10.1723 20.4707 10.7986C21.063 11.4393 21.4272 12.2466 21.6349 13.0893C21.3693 12.791 21.3302 12.6549 20.8682 12.4659C20.818 12.4458 20.7689 12.4228 20.7213 12.3972Z"
      fill="#003146"
    />
    <path
      d="M13.8653 8.67078C13.0617 8.38625 10.8042 7.72959 10.1172 7.21338C10.2004 7.81213 10.7832 8.02497 10.9136 8.42389C11.0519 8.8525 10.5378 9.46356 10.6189 9.92475C11.0939 9.37523 12.6157 9.48528 13.0907 8.93504L13.8653 8.67078Z"
      fill="#007FA4"
    />
    <path
      d="M13.1675 8.76118L13.0068 8.54398C13.0068 8.45493 14.6937 8.20732 14.8704 8.1675C14.9572 8.14795 15.2628 9.23467 15.3728 9.44463C15.8015 10.262 16.267 10.8087 17.1677 11.0678C16.0035 11.2742 16.4639 11.5022 15.3765 10.257C15.1448 9.99198 14.6684 9.30925 14.4295 9.32011C14.053 9.33748 13.544 8.7467 13.1675 8.76407V8.76118Z"
      fill="#EFEFEF"
    />
    <path
      d="M12.9467 8.55558C12.9748 8.53654 13.0063 8.52307 13.0395 8.51576L13.1545 8.44336L14.4288 8.69966C14.987 9.96159 15.7052 10.7392 16.6109 11.0425L17.167 11.0621C17.3204 11.1091 17.3842 11.5262 17.4052 11.6203C17.487 11.9381 17.471 12.4493 17.4218 12.5709L16.0513 12.3016C15.7139 12.1408 16.0281 11.9721 15.7052 11.781C14.7082 11.1794 15.85 12.9756 15.1774 12.1387C15.1622 12.1387 15.4764 12.3472 16.1331 12.4283L15.391 12.3175L15.5568 12.3305C15.6509 12.513 18.1538 12.7519 15.412 12.4391C15.0305 12.395 16.2193 12.4536 16.6891 12.3218L17.437 12.0576L18.2291 11.676L18.0379 12.2777C17.9475 12.4841 17.8836 12.7011 17.8475 12.9235L17.3342 13.0263C17.0844 13.0697 16.8643 13.0842 16.7036 13.0408L16.3365 12.9083C16.0281 12.791 15.5293 12.8207 14.8545 13.0111C14.3853 13.1436 13.8518 13.1747 13.4565 13.0422C13.0612 12.9097 12.9496 12.7034 12.9033 12.4681L12.9467 12.1893C12.9583 12.1314 12.9633 12.0724 12.9619 12.0134C12.8592 11.8816 12.7269 11.7057 12.5652 11.4856C12.4773 11.3591 12.3641 11.252 12.233 11.1712C12.1019 11.0904 11.9554 11.0375 11.8028 11.0157C11.4848 10.9759 11.1701 10.9123 10.8617 10.8253C10.8062 10.799 10.7523 10.7695 10.7002 10.737C10.7443 10.341 11.1107 9.86819 11.8151 9.32881"
      fill="#007FA4"
    />
    <path
      d="M8.92755 15.5111C9.65592 14.5315 10.4211 13.5527 11.2603 12.6643C9.62038 14.9087 8.85004 17.9814 10.7723 20.2974C11.1621 20.7599 11.6067 21.1733 12.0965 21.5282C13.0234 21.3013 13.9708 21.1689 14.9244 21.1329C16.8561 21.0649 18.779 21.4312 20.5775 22.1299C19.4277 23.6626 18.1245 22.0003 16.5882 21.7216C14.9642 21.4276 13.3027 21.7715 11.8054 22.4159C10.8737 22.817 10.6702 22.2182 10.0186 21.5319C9.46673 20.9553 8.94434 20.3512 8.45328 19.7219C8.15575 19.3381 6.91846 18.0987 7.19138 17.6729C7.68808 16.8975 8.38815 16.2604 8.929 15.5154L8.92755 15.5111Z"
      fill="#007FA4"
    />
    <path
      d="M10.3798 13.6764C8.35842 14.2245 8.67194 12.7352 9.4082 11.487C9.6602 11.0606 10.4776 8.13056 11.8177 9.33385C9.83896 11.1439 12.3809 10.6371 13.1151 11.6507C13.3149 11.9229 13.2042 12.5477 12.9037 12.4717C13.0992 13.52 14.8752 12.9683 15.471 12.8771C16.5983 12.7055 17.8153 13.0979 18.9976 12.935C20.2595 12.7605 20.7736 11.8787 21.6337 13.0878C21.8929 14.0869 21.9154 15.1592 21.8683 16.1843C19.9493 14.6839 17.6347 13.7751 15.2075 13.5693C14.8527 13.5381 14.0491 13.3694 13.7269 13.5577C12.7531 14.5713 12.2507 16.0352 12.7929 17.3123C13.4127 18.7734 15.2987 21.985 17.1746 20.5783C17.8667 20.0592 18.2237 19.3099 19.0968 18.9855C20.1705 18.588 21.3868 18.8537 22.3389 19.4257C22.0145 19.6052 21.452 19.6045 21.3666 19.9651C21.0769 21.1923 20.922 21.7027 20.5788 22.1255C18.3344 21.2531 16.1515 20.9229 13.8731 21.7591C11.9994 22.4462 10.7758 21.9727 10.2358 20.6051C9.90417 19.766 9.83534 19.5502 9.6906 18.5916C9.32858 16.1771 10.0772 14.2809 11.2617 12.6621C10.9554 12.9864 10.7093 13.3723 10.3813 13.6757L10.3798 13.6764Z"
      fill="#EFEFEF"
    />
    <path
      d="M16.6151 12.0156C16.6151 12.6317 16.2936 13.1305 15.8969 13.1305C15.5001 13.1305 15.1787 12.6317 15.1787 12.0156C15.1787 11.3995 15.5001 10.8999 15.8969 10.8999C16.2936 10.8999 16.6151 11.4009 16.6151 12.0156Z"
      fill="white"
    />
    <path
      d="M16.6143 12.0156C16.6143 12.3451 16.4586 12.6122 16.2667 12.6122C16.0749 12.6122 15.9199 12.3451 15.9199 12.0156C15.9199 11.6862 16.0756 11.4191 16.2667 11.4191C16.4579 11.4191 16.6143 11.6862 16.6143 12.0156Z"
      fill="#003146"
    />
    <path
      d="M14.9922 10.7081C15.4562 11.3112 16.1368 11.7999 16.6899 12.327C16.8688 10.9999 16.0767 10.4822 14.9922 10.7081Z"
      fill="#EFEFEF"
    />
    <path
      d="M4.6961 12.8011L7.78324 12.2103L9.74529 15.9288L6.86663 18.5555L4.40723 14.8819L4.6961 12.8011Z"
      fill="#007FA4"
    />
    <path
      d="M17.168 17.1582C17.8869 17.6172 18.4299 18.3709 18.7962 19.3816L18.3416 19.6205C18.0687 19.8538 17.8182 20.1122 17.5937 20.3923C17.6149 19.299 17.4714 18.2088 17.168 17.1582Z"
      fill="#EFEFEF"
    />
    <path
      d="M18.6406 17.0409C18.8897 16.1091 18.9186 15.1397 18.7579 14.1326C19.2884 14.4062 19.7985 14.7179 20.2841 15.0651C20.0669 15.6226 19.6325 16.474 18.6406 17.0409Z"
      fill="#EFEFEF"
    />
    <path
      d="M3.46484 13.0892L4.80859 12.3218C4.80859 12.3218 5.09819 15.6833 6.58529 16.9633C6.85604 17.1972 7.5779 17.4108 7.34333 17.7771C7.09212 18.1688 7.82983 18.8682 8.06229 19.1933C8.80217 20.2185 9.39513 20.5109 9.11497 21.762C8.92889 22.5932 9.40453 23.9485 9.11497 23.8841C6.32178 23.2578 3.46484 13.0892 3.46484 13.0892Z"
      fill="#007FA4"
    />
    <path
      d="M7.78259 12.2104C8.45082 11.6761 10.0878 9.09717 10.8198 9.09717C10.2007 10.1441 7.02238 14.5851 10.3796 13.675C9.8815 14.2752 9.39276 14.8834 8.92726 15.5096C8.38713 14.8392 6.64879 12.9756 7.78259 12.303V12.2104Z"
      fill="#007FA4"
    />
    <path
      d="M20.8008 18.911C20.4361 18.8499 20.0633 18.8549 19.7003 18.9255C19.9349 18.1921 19.9052 17.4587 19.6279 16.7101C20.4062 17.2234 20.8023 17.9568 20.8023 18.911H20.8008Z"
      fill="#EFEFEF"
    />
    <path
      d="M12.8412 17.492C16.0521 16.1461 18.526 24.0768 14.2363 23.8806C12.8064 23.8147 11.2223 21.0194 13.1988 21.0194C14.7076 21.0194 15.3331 19.651 13.8048 19.3274L12.8412 17.492Z"
      fill="#F26A36"
    />
    <path
      d="M13.7785 19.3273C13.9892 18.6952 14.3707 18.4802 14.9659 18.1754C14.7849 19.0594 14.6995 20.1961 14.651 20.2649C14.1927 19.9297 14.092 19.8761 13.7785 19.2897C13.7517 19.2382 13.7785 19.3273 13.7785 19.3273Z"
      fill="#EFEFEF"
    />
    <path
      d="M8.88403 20.2547C8.90501 20.1222 9.29742 20.7267 9.4371 20.899C10.2335 21.8344 11.6207 22.5744 10.7027 23.6017C9.1099 25.3813 7.0233 23.5532 8.06874 22.6605C9.11425 21.7678 8.88403 20.2547 8.88403 20.2547Z"
      fill="#EFEFEF"
    />
    <path
      d="M6.75591 20.4546C5.5933 18.6932 4.97511 16.6283 4.97848 14.5178C4.97937 13.6829 5.07654 12.8508 5.26808 12.0381L3.50296 12.1496C3.23181 12.1671 2.97577 12.2806 2.78074 12.4699C2.58571 12.6591 2.46444 12.9115 2.43868 13.182C2.39428 13.6251 2.37207 14.0704 2.37207 14.5178C2.37107 16.7663 2.93573 18.9789 4.01406 20.952C5.09239 22.9251 6.64974 24.5952 8.54274 25.8086C8.77014 25.9532 9.0414 26.0127 9.30845 25.9764C9.57551 25.9401 9.82108 25.8103 10.0016 25.6102L11.1897 24.2954C9.38604 23.4482 7.85165 22.119 6.75591 20.4546Z"
      fill="#81C9DE"
    />
    <path
      d="M3.61954 14.0385C3.85546 14.0385 4.0467 13.8472 4.0467 13.6114C4.0467 13.3755 3.85546 13.1842 3.61954 13.1842C3.38362 13.1842 3.19238 13.3755 3.19238 13.6114C3.19238 13.8472 3.38362 14.0385 3.61954 14.0385Z"
      fill="#D6E7F1"
    />
    <path
      d="M3.64688 16.1627C3.8828 16.1627 4.07405 15.9715 4.07405 15.7355C4.07405 15.4996 3.8828 15.3083 3.64688 15.3083C3.41097 15.3083 3.21973 15.4996 3.21973 15.7355C3.21973 15.9715 3.41097 16.1627 3.64688 16.1627Z"
      fill="#D6E7F1"
    />
    <path
      d="M4.0424 18.2492C4.27831 18.2492 4.46955 18.058 4.46955 17.8221C4.46955 17.5862 4.27831 17.3949 4.0424 17.3949C3.80648 17.3949 3.61523 17.5862 3.61523 17.8221C3.61523 18.058 3.80648 18.2492 4.0424 18.2492Z"
      fill="#D6E7F1"
    />
    <path
      d="M4.79435 20.2359C5.03026 20.2359 5.22151 20.0447 5.22151 19.8088C5.22151 19.5729 5.03026 19.3816 4.79435 19.3816C4.55844 19.3816 4.36719 19.5729 4.36719 19.8088C4.36719 20.0447 4.55844 20.2359 4.79435 20.2359Z"
      fill="#D6E7F1"
    />
    <path
      d="M5.87928 22.0618C6.11521 22.0618 6.3065 21.8706 6.3065 21.6347C6.3065 21.3988 6.11521 21.2075 5.87928 21.2075C5.64341 21.2075 5.45215 21.3988 5.45215 21.6347C5.45215 21.8706 5.64341 22.0618 5.87928 22.0618Z"
      fill="#D6E7F1"
    />
    <path
      d="M7.26602 23.6719C7.50195 23.6719 7.69324 23.4807 7.69324 23.2448C7.69324 23.0089 7.50195 22.8176 7.26602 22.8176C7.03015 22.8176 6.83887 23.0089 6.83887 23.2448C6.83887 23.4807 7.03015 23.6719 7.26602 23.6719Z"
      fill="#D6E7F1"
    />
    <path
      d="M8.91055 25.0164C9.14641 25.0164 9.3377 24.8251 9.3377 24.5893C9.3377 24.3534 9.14641 24.1621 8.91055 24.1621C8.67461 24.1621 8.4834 24.3534 8.4834 24.5893C8.4834 24.8251 8.67461 25.0164 8.91055 25.0164Z"
      fill="#D6E7F1"
    />
    <path
      d="M15.0659 24.8825C20.6079 24.8825 25.1006 20.3899 25.1006 14.8479C25.1006 9.30589 20.6079 4.81323 15.0659 4.81323C9.5239 4.81323 5.03125 9.30589 5.03125 14.8479C5.03125 20.3899 9.5239 24.8825 15.0659 24.8825Z"
      stroke="#D6E7F1"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="0.502242"
    />
    <path
      d="M12.2678 26.4985C12.385 26.4985 12.4799 26.4035 12.4799 26.2864C12.4799 26.1692 12.385 26.0742 12.2678 26.0742C12.1506 26.0742 12.0557 26.1692 12.0557 26.2864C12.0557 26.4035 12.1506 26.4985 12.2678 26.4985Z"
      fill="#81C9DE"
    />
    <path
      d="M14.5237 3.62226C14.6408 3.62226 14.7358 3.52728 14.7358 3.41013C14.7358 3.29297 14.6408 3.198 14.5237 3.198C14.4065 3.198 14.3115 3.29297 14.3115 3.41013C14.3115 3.52728 14.4065 3.62226 14.5237 3.62226Z"
      fill="#81C9DE"
    />
    <path
      d="M27.5481 11.9736C27.6652 11.9736 27.7602 11.8786 27.7602 11.7614C27.7602 11.6443 27.6652 11.5493 27.5481 11.5493C27.4309 11.5493 27.3359 11.6443 27.3359 11.7614C27.3359 11.8786 27.4309 11.9736 27.5481 11.9736Z"
      fill="#81C9DE"
    />
    <path
      d="M4.27756 11.2446C4.39472 11.2446 4.48969 11.1496 4.48969 11.0324C4.48969 10.9153 4.39472 10.8203 4.27756 10.8203C4.16041 10.8203 4.06543 10.9153 4.06543 11.0324C4.06543 11.1496 4.16041 11.2446 4.27756 11.2446Z"
      fill="#81C9DE"
    />
    <path
      d="M5.24338 7.57746C5.36054 7.57746 5.45551 7.48249 5.45551 7.36533C5.45551 7.24817 5.36054 7.1532 5.24338 7.1532C5.12623 7.1532 5.03125 7.24817 5.03125 7.36533C5.03125 7.48249 5.12623 7.57746 5.24338 7.57746Z"
      fill="#81C9DE"
    />
    <path
      d="M17.0442 27.116C17.1613 27.116 17.2563 27.021 17.2563 26.9039C17.2563 26.7868 17.1613 26.6918 17.0442 26.6918C16.927 26.6918 16.832 26.7868 16.832 26.9039C16.832 27.021 16.927 27.116 17.0442 27.116Z"
      fill="#81C9DE"
    />
    <path
      d="M19.7203 3.24648C19.8879 3.24648 20.0237 3.11067 20.0237 2.94313C20.0237 2.77559 19.8879 2.63977 19.7203 2.63977C19.5528 2.63977 19.417 2.77559 19.417 2.94313C19.417 3.11067 19.5528 3.24648 19.7203 3.24648Z"
      fill="#81C9DE"
    />
    <path
      d="M26.0759 18.6112C26.2434 18.6112 26.3792 18.4754 26.3792 18.3079C26.3792 18.1403 26.2434 18.0045 26.0759 18.0045C25.9083 18.0045 25.7725 18.1403 25.7725 18.3079C25.7725 18.4754 25.9083 18.6112 26.0759 18.6112Z"
      fill="#81C9DE"
    />
    <path
      d="M23.0209 24.6631C23.2553 24.6631 23.4452 24.4731 23.4452 24.2388C23.4452 24.0046 23.2553 23.8146 23.0209 23.8146C22.7867 23.8146 22.5967 24.0046 22.5967 24.2388C22.5967 24.4731 22.7867 24.6631 23.0209 24.6631Z"
      fill="#81C9DE"
    />
    <path
      d="M7.91475 4.81397C8.11464 4.81397 8.27676 4.65189 8.27676 4.45197C8.27676 4.25204 8.11464 4.08997 7.91475 4.08997C7.71478 4.08997 7.55273 4.25204 7.55273 4.45197C7.55273 4.65189 7.71478 4.81397 7.91475 4.81397Z"
      fill="#81C9DE"
    />
    <path
      d="M23.6986 4.89294L23.9629 6.14547L24.8005 6.40973L23.9629 6.67326L23.6986 7.92579L23.4343 6.67326L22.5967 6.40973L23.4343 6.14547L23.6986 4.89294Z"
      fill="#81C9DE"
    />
    <path
      d="M16.3574 6.55444C17.4721 6.72793 18.5404 7.12447 19.4982 7.72034C20.4562 8.31622 21.284 9.09915 21.9323 10.0224"
      stroke="#D6E7F1"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="0.502242"
    />
  </svg>
);
